import theme from "@config/theme";
import { NewsletterSignup } from "@components/newsletter/NewsletterSignup";

type NewsletterSignupProps = {
  pageSource: string;
};

const NewsletterContainerLight = ({ pageSource }: NewsletterSignupProps) => (
  <div className="newsletter-container-light">
    <div>
      <h3 className="newsletter-title-light">Subscribe to our newsletter</h3>
      <p>
        Expert tips, exciting projects, and IoT insights delivered every month
      </p>
    </div>
    <NewsletterSignup pageSource={pageSource} />
    <style jsx>
      {`
        .newsletter-container-light {
          padding: 2rem 1.5rem 1rem 1.5rem;
          max-width: 950px;
          margin: auto;
          border: 1px solid ${theme.colors.gray4};
          border-radius: 5px;
          display: flex;
          justify-content: space-around;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
        }

        .newsletter-title-light {
          font-size: ${theme.fonts.size.px24};
          margin: 0;
        }

        @media screen and (max-width: ${theme.breakpoints.md}px) {
          .newsletter-container {
            flex-direction: column;
            align-items: flex-start;
          }
        }

        @media screen and (max-width: ${theme.breakpoints.noReplMobile}px) {
          .newsletter-title {
            text-align: center;
          }
        }
      `}
    </style>
  </div>
);

export { NewsletterContainerLight };
